export default class AdminAuditTrail {
  axiosIns = null
  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.adminAuditTrail, {
      params
    })
  }

  export(params) {
    return this.axiosIns.get(`${this.jwtConfig.main.adminAuditTrail}/export`, {
      params,
      responseType: "blob"
    })
  }
}
